import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {lastValueFrom} from 'rxjs';
import {userInfoStore} from '../elf-store/user-info/user-info.store';
import {AuthService} from '../../auth/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class FixMyCodeAccessGuard {
  private router = inject(Router);
  private authService = inject(AuthService);
  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const isEnabled = await this.isCanBeActivated();
    if (!isEnabled) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }

  async isCanBeActivated(): Promise<boolean> {
    const userInfo = userInfoStore.getValue().userInfo;
    if (!userInfo?.isFixMyCodeEnabled) {
      await lastValueFrom(this.authService.loadUserOrTeamDataBasedOnSwitch());
    }
    return userInfoStore.getValue().userInfo?.isFixMyCodeEnabled ?? false;
  }
}
